module.exports = __webpack_public_path__ + "img/m_1.1ba45afa.png";